import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import PlayerCard from '../PlayerCard/PlayerCard';
import { usePlayer } from '../../context/PlayerContext';
import './PlayerList.scss';

const PlayerList = () => {
  const { getFilteredPlayers, searchTerm } = usePlayer();
  const players = getFilteredPlayers();

  if (players.length === 0) {
    return (
      <Box className="empty-state">
        <div className="empty-icon">♠</div>
        <Typography variant="h5" className="empty-title">
          {searchTerm ? 'No players found' : 'No players yet'}
        </Typography>
        <Typography variant="body1" color="text.secondary" className="empty-subtitle">
          {searchTerm 
            ? `Try searching for a different name` 
            : 'Start by adding your first player to track buy-ins'
          }
        </Typography>
      </Box>
    );
  }

  return (
    <Box className="player-list">
      <Grid container spacing={3}>
        {players.map((player) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={player.id}>
            <PlayerCard player={player} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PlayerList;